<ng-container *ngIf="user$ | async as user; else notConnected">
  <div class="row">
      <div class="col-12 col-md-8">
          <p>{{ 'components.identification-provider.identified-with' | translate: { userName: user.displayName } }}</p>
          <button mat-raised-button (click)="logout()">
              {{ 'actions.log-out' | translate }}
          </button>
      </div>
      <div class="col-12 col-md-4">
          <div class="identification-provider" [ngSwitch]="user.identityProvider">
              <ng-container *ngTemplateOutlet="providerImg; context: { $implicit: user.identityProvider }"></ng-container>
          </div>
      </div>
  </div>
</ng-container>
<ng-template #notConnected>
  <p>{{ 'components.identification-provider.choose-provider' | translate }}</p>
  <div class="identity-providers-list">
      <ng-container *ngFor="let identityProvider of providersList">
          <ng-container *ngTemplateOutlet="loginButton; context: { $implicit: identityProvider }"></ng-container>
      </ng-container>
  </div>    
</ng-template>

<ng-template #loginButton let-identityProvider>
  <button mat-raised-button (click)="login(identityProvider)">
      <ng-container *ngTemplateOutlet="providerImg; context: { $implicit: identityProvider }"></ng-container>
  </button>
</ng-template>

<ng-template #providerImg let-identityProvider>
  <ng-container [ngSwitch]="identityProvider">
      <img *ngSwitchCase="IdentificationProvider.GENEVE_ID" src="assets/images/identification/logo-geneveid.png" alt="Genève ID" title="Genève ID" />
      <img *ngSwitchCase="IdentificationProvider.VAUD_ID" src="assets/images/identification/logo-vaudid.png" alt="Vaud ID" title="Vaud ID" />
      <img *ngSwitchCase="IdentificationProvider.TRUST_ID" src="assets/images/identification/logo-trustid.svg" alt="TrustID" title="TrustID" />
      <img *ngSwitchCase="IdentificationProvider.SWISS_ID" src="assets/images/identification/logo-swissid.svg" alt="SwissID" title="SwissID" />
      <img *ngSwitchCase="IdentificationProvider.HIN" src="assets/images/identification/logo-hin.png" alt="eID HIN" title="eID HIN" />
  </ng-container>
</ng-template>